/**
 * APIL Url: ADAC.Internet.Types.Person.PrivacyAcceptance
 * Zustimmung zur Datenverwendung, Werte: Unknown = 0; Agreed = 1; Declined = 2; 
 */
export enum PrivacyAcceptanceApi {
	Unknown = 0,  // Unknown
	Agreed = 1,  // Agreed
	Declined = 2  // Declined
};